<template>
  <div>
    <v-layout class="text-xs-right">
      <v-btn  @click="openDialog()" :color="ui.bkgdColor" icon>
        <v-icon :color="ui.btnColor"> source </v-icon>
      </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
        <v-card color="wplgrey0">
          <v-card-title :class="ui.textTitle">
            Risk Assessment
            <v-spacer/>
            {{displayDocumentIDGTypeA(riskAssessment.basic.tag, riskAssessment.basic.idg)}}
          </v-card-title>
          <v-progress-linear :color="ui.textColor" height="1" value="100">
          </v-progress-linear>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout row :class="ui.textSubheading">
                <div class="ml-4 mt-4">
                  Risk Identification
                </div>
              </v-layout>
              <v-layout row class="ml-2 mr-2">
                <v-flex xs10>
                  <v-text-field
                  v-model="selectedRiskAssessmentItem.basic.title"
                  label="risk assessment title"
                  prepend-icon="title"
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs10 sm5>
                  <v-text-field
                  v-model="selectedRiskAssessmentItem.basic.id"
                  label="risk id"
                  prepend-icon="sell"
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs10 sm5>
                  <v-text-field
                  v-model="selectedRiskAssessmentItem.char.ref"
                  label="reference"
                  prepend-icon="share"
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row :class="ui.textSubheading">
                <div class="ml-4 mt-4">
                  Scenario and Context
                </div>
              </v-layout>
              <v-layout row class="ml-2 mt-2">
                <v-flex xs10 offset-xs1>
                  <InfoDateAgoName :data="this.selectedRiskAssessmentItem.stats"/>
                </v-flex>
              </v-layout>
              <v-layout row class="ml-2">
                <v-flex xs10 offset-xs1>
                  <v-textarea
                   v-model="selectedRiskAssessmentItem.char.com"
                   :outline="true"
                   hint="risk assessment description"
                   auto-grow
                   readonly
                   ></v-textarea>
                </v-flex>
              </v-layout>
              <!-- <v-layout row wrap class="ml-2 mr-2" v-if="activeList.length > 0">
                <v-flex xs12>
                  <v-item-group>
                    <v-item :key="n" v-for="n in activeList.length">
                      <v-chip
                        outline
                        :color="ui.chipColorStd"
                        slot-scope="{ active, toggle }"
                        :selected="active"
                        @click="toggle"
                      >
                        {{ activeList[n-1]}}
                      </v-chip>
                    </v-item>
                  </v-item-group>
                </v-flex>
              </v-layout> -->
              <v-layout row :class="ui.textSubheading">
                <div class="ml-4 mt-3">
                  Barriers and Risk Controls
                </div>
              </v-layout>
              <v-layout class="mr-2">
                <v-flex xs10 offset-xs1>
                  <v-text-field
                  v-model="selectedRiskAssessmentItem.char.cause"
                  prepend-icon="low_priority"
                  required
                  hint="possible causes"
                  readonly
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs10 offset-xs1>
                  <v-text-field
                  v-model="selectedRiskAssessmentItem.char.bar"
                  prepend-icon="shield"
                  required
                  hint="existing barriers to control risk"
                  readonly
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs10 offset-xs1>
                  <v-text-field
                  v-model="selectedRiskAssessmentItem.char.cont"
                  prepend-icon="health_and_safety"
                  hint="additional or existing risk control"
                  readonly
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs10 sm5 offset-xs1 offset-sm1>
                  <v-text-field
                  v-model="selectedRiskAssessmentItem.char.bars"
                  prepend-icon="assessment"
                  hint="barrier stat."
                  readonly
                  persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs10 sm5 offset-xs1  offset-sm0>
                  <v-text-field
                  v-model="selectedRiskAssessmentItem.char.conts"
                  prepend-icon="analytics"
                  hint="control stat."
                  readonly
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap :class="ui.textSubheading">
                <div class="ml-4 mt-4">
                  Risk Assessment
                </div>
                <v-spacer/>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs10 sm5 offset-xs1 offset-sm1>
                  <v-text-field
                  v-model="selectedRiskAssessmentItem.char.type"
                  prepend-icon="emergency"
                  hint="risk type"
                  persistent-hint
                  required
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs10 sm5 offset-xs1  offset-sm0>
                  <v-text-field
                  v-model="selectedRiskAssessmentItem.char.comp"
                  prepend-icon="today"
                  hint="compliance"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs10 sm5 offset-xs1 offset-sm1>
                  <v-text-field
                  v-model="selectedRiskAssessmentItem.char.cond"
                  prepend-icon="swap_horizontal_circle"
                  hint="condition"
                  persistent-hint
                  required
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs10 sm5 offset-xs1  offset-sm0>
                  <v-text-field
                  v-model="selectedRiskAssessmentItem.char.time"
                  prepend-icon="schedule"
                  hint="timing"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs10 sm5 offset-xs1 offset-sm1>
                  <v-text-field
                  v-model="selectedRiskAssessmentItem.char.cat"
                  prepend-icon="scatter_plot"
                  hint="risk category"
                  persistent-hint
                  required
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs10 sm5 offset-xs1  offset-sm0>
                  <v-text-field
                  v-model="risk"
                  prepend-icon="leaderboard"
                  hint="risk rating"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs5 offset-xs1>
                  <v-text-field
                  v-model="selectedRiskAssessmentItem.char.cons"
                  prepend-icon="local_fire_department"
                  hint="consequence"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs5>
                  <v-text-field
                  v-model="selectedRiskAssessmentItem.char.like"
                  prepend-icon="casino"
                  hint="likelihood"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs10 offset-xs1>
                  <v-text-field
                  v-model="selectedRiskAssessmentItem.char.sum"
                  prepend-icon="adjust"
                  required
                  hint="risk assessment conclusion"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
            <v-layout row>
              <v-btn @click="closeDialog()" :color="ui.btnColor" flat>
                <v-icon left> exit_to_app </v-icon>
                Close
              </v-btn>
              <v-spacer/>
              <v-btn @click="closeDialog()" :color="ui.btnColor" flat>
                <v-icon left> leaderboard </v-icon>
                Score {{riskValueCalc(selectedRiskAssessmentItem.char.cons, selectedRiskAssessmentItem.char.like)}}
              </v-btn>
            </v-layout>
          </v-form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import InfoDateAgoName from "@/frame/display/components/InfoDateAgoName";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import riskOptions from "@/data/options/mixins/riskOptions.js";
import riskFunctions from "@/data/functions/mixins/riskFunctions.js";
import master from "@/data/forms/mixins/master.js";
export default {
  // eslint-disable-next-lineprog
  mixins: [
    master,
    dateFunctions,
    apptheme,
    numberFunctions,
    riskOptions,
    displayFunctions,
    riskFunctions
  ],
  // components: {
  //   TaskItemSummaryBar
  // },
  components: {
    InfoDateAgoName
  },
  computed: {
    ...mapGetters(["getRiskAssessmentList", "getCurrentPage"]),
    // selected task item
    selectedRiskAssessmentItem() {
      return this.riskAssessment;
    },
    activeList() {
      let list = null;
      list = this.selectedRiskAssessmentItem.char.cause;
      return list;
    }
  },
  props: {
    riskAssessment: {
      type: Object
    }
  },
  beforeMount() {
    this.risk = this.riskValueCalc(
      this.selectedRiskAssessmentItem.char.cons,
      this.selectedRiskAssessmentItem.char.like
    );
  },
  data() {
    return {
      dialog: false,
      valid: false,
      risk: 8
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    }
  }
};
</script>
